
        var result = require("!!../../../../../node_modules/css-loader/index.js!./mailing-add.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/marketing/mailing/dialogs/mailing-add.component.css
// module id = 2531
// module chunks = 1